var _defs, _g, _line, _line2, _g2, _line3, _g3, _line4, _line5, _line6, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapIcon4 = function SvgMapIcon4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_104",
    "data-name": "Group 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.687,
    height: 26.5,
    viewBox: "0 0 32.687 26.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 32.687,
    height: 26.5,
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 10.918,
    transform: "translate(11.024 26)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x1: 5.9,
    y1: 5.9,
    transform: "translate(10.731 14.549)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y1: 5.9,
    x2: 5.9,
    transform: "translate(15.944 14.549)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x1: 10.918,
    transform: "translate(11.024 0.5)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 5.9,
    y2: 5.9,
    transform: "translate(16.042 5.324)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x2: 5.9,
    y2: 5.9,
    transform: "translate(26.433 5.324)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 5.9,
    y2: 5.9,
    transform: "translate(5.567 5.324)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x1: 5.9,
    y2: 5.9,
    transform: "translate(10.797 5.324)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x1: 5.9,
    y2: 5.9,
    transform: "translate(21.241 5.324)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x1: 5.9,
    y2: 5.9,
    transform: "translate(0.354 5.324)",
    fill: "none",
    stroke: "#ebddbb",
    strokeWidth: 1
  })))));
};

export { SvgMapIcon4 as ReactComponent };
export default "data:image/svg+xml;base64,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";